/**
 * Hariom ERP - Inventory store (persisted, starts empty).
 * Employees add the real products; data survives navigation + refresh.
 */
import { createCrudStore } from './createCrudStore'

export interface InvProduct {
  id: string
  code: string
  name: string
  category: string
  stock: number
  min: number
  max: number
  unit: string
  price: number
  location: string
}

export const useInventoryStore = createCrudStore<InvProduct>('hariom-erp-inventory')
